export const categories = [
  {
    slug: 'hero-guide',
    name: '英雄攻略',
    description: '全英雄详细玩法解析，技能连招与对位技巧',
    icon: 'ri-user-star-line',
    color: 'accent',
  },
  {
    slug: 'item-build',
    name: '出装推荐',
    description: '最新版本出装思路与装备搭配方案',
    icon: 'ri-sword-line',
    color: 'primary',
  },
  {
    slug: 'laning-tips',
    name: '对线技巧',
    description: '各位置对线细节与压制策略',
    icon: 'ri-crosshair-line',
    color: 'secondary',
  },
  {
    slug: 'teamfight',
    name: '团战策略',
    description: '团战站位、开团时机与配合思路',
    icon: 'ri-team-line',
    color: 'accent',
  },
  {
    slug: 'rank-climb',
    name: '段位提升',
    description: '从青铜到王者的系统性上分方法论',
    icon: 'ri-bar-chart-line',
    color: 'primary',
  },
  {
    slug: 'meta-tier',
    name: '版本强势',
    description: '当前版本T0-T1英雄评级与Ban/Pick指南',
    icon: 'ri-fire-line',
    color: 'secondary',
  },
];

export const articles = [
  {
    id: 'art-001',
    slug: 'yasuo-complete-guide',
    title: '亚索全方位攻略：从入门到疾风剑豪',
    excerpt: '疾风剑豪亚索是撸啊撸中最具人气的英雄之一。本攻略从技能机制、连招技巧、出装思路到对线打法，全方位解析亚索的玩法精髓。',
    category: 'hero-guide',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20samurai%20swordsman%20champion%20with%20golden%20amber%20warm%20glow%2C%20dark%20atmospheric%20gaming%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20professional%20esports%20aesthetic&width=800&height=500&seq=yasuo-guide-hero&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20samurai%20icon%20golden%20amber%20tones%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=yasuo-guide-hero-thumb&orientation=squarish',
    readTime: 12,
    publishDate: '2026-08-05',
    hot: true,
    featured: true,
    tags: ['亚索', '中单', '刺客', '疾风剑豪'],
    content: {
      intro: '疾风剑豪亚索是撸啊撸中操作上限极高的中单刺客英雄，凭借灵活的位移和高爆发伤害深受玩家喜爱。本篇撸啊撸英雄攻略将带你深入掌握亚索的每一个细节。',
      sections: [
        {
          heading: '技能机制详解',
          content: '亚索的被动「浪客之道」提供双倍暴击几率和护盾，这是他生存和输出的核心。Q技能「斩钢闪」是主要的消耗和清线手段，第三次Q会释放旋风击飞敌人。W技能「风之壁障」可以阻挡所有飞行道具，是亚索最强大的防御技能。E技能「踏前斩」提供无与伦比的机动性，可以穿越兵线和野怪。R技能「狂风绝息斩」是亚索的终极技能，可以瞬移到被击飞的敌人身边造成巨额伤害。',
        },
        {
          heading: '连招技巧',
          content: '基础连招：E小兵接近 → Q → A → E敌人 → Q → A。进阶连招：Q3旋风击飞 → EQR（空中Q）→ A → Q。亚索的EQ闪是超高阶技巧，可以在闪现的同时释放EQ造成出其不意的击飞。撸啊撸出装推荐选择不朽盾弓作为神话装备，搭配无尽之刃和饮血剑形成核心三件套。',
        },
        {
          heading: '对线打法',
          content: '面对远程法师时，利用W风墙挡关键技能，E小兵灵活走位躲消耗。近战对位时利用Q的射程优势poke。六级后配合打野可以轻松击杀。撸啊撸对线技巧的关键在于控制兵线位置，让E技能有更多的操作空间。',
        },
        {
          heading: '团战思路',
          content: '亚索在团战中的定位是后排杀手。不要第一时间进场，等待队友的控制技能先手击飞，然后R技能跟进收割。也可以利用W风墙保护己方ADC。撸啊撸团战策略中，亚索需要把握好进场时机，过早进场容易被集火秒杀。',
        },
      ],
    },
  },
  {
    id: 'art-002',
    slug: 's14-meta-tier-list',
    title: 'S14赛季版本强势英雄排行榜：T0-T1全位置评级',
    excerpt: '撸啊撸S14赛季最新版本强势英雄排行榜，涵盖上单、打野、中单、ADC、辅助五个位置的T0-T1级别英雄推荐，助你快速上分。',
    category: 'meta-tier',
    image: 'https://readdy.ai/api/search-image?query=Esports%20tier%20list%20ranking%20with%20golden%20and%20amber%20glowing%20charts%2C%20dark%20competitive%20gaming%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20arena%20vibe%2C%20dramatic%20composition&width=800&height=500&seq=meta-tier-list&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=Esports%20ranking%20trophy%20icon%20golden%20amber%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=meta-tier-list-thumb&orientation=squarish',
    readTime: 8,
    publishDate: '2026-08-06',
    hot: true,
    featured: true,
    tags: ['版本强势', 'T0英雄', '排位', '上分推荐'],
    content: {
      intro: 'S14赛季版本更新带来了大量的英雄调整和装备改动，撸啊撸版本强势英雄的格局发生了显著变化。本文为你整理当前版本各位置的T0-T1级英雄，助你在排位中占据先机。',
      sections: [
        {
          heading: '上单：坦克回归',
          content: '当前版本上单以坦克和战士为主。奥恩凭借强大的团战能力和装备升级机制稳坐T0宝座。其次是剑姬和鳄鱼，在对线期具有极强的压制力。撸啊撸段位提升的关键在于选择版本强势的上单英雄，利用线权优势帮助打野控资源。',
        },
        {
          heading: '打野：节奏为王',
          content: '李青和蜘蛛女皇是当前打野位的T0选择，前期的gank能力无与伦比。佛耶戈和赵信紧随其后，在中期团战中有着出色的表现。打野的核心思路是控制河蟹和龙区视野。',
        },
        {
          heading: '中单：法师与刺客并存',
          content: '亚索和阿狸是当前中路最热门的选择。阿狸凭借灵活的位移和稳定的控制在中路有着极高的胜率。塞拉斯作为counter位选择也有着不俗的表现。',
        },
        {
          heading: 'ADC：攻速流崛起',
          content: '金克丝和泽丽是当前版本最强的ADC选择，攻速流装备的加强让她们的后期输出能力达到了新的高度。卢锡安在前期的压制力依然出色。',
        },
        {
          heading: '辅助：硬辅称霸',
          content: '蕾欧娜和泰坦是当前版本辅助位的T0选择，强大的开团能力和坦度让她们在职业赛场上也备受青睐。露露作为保护型辅助在面对刺客阵容时是绝佳选择。',
        },
      ],
    },
  },
  {
    id: 'art-003',
    slug: 'mid-lane-laning-guide',
    title: '中单对线终极指南：兵线控制与游走时机',
    excerpt: '掌握中单对线的核心技巧，从兵线管理、换血时机到游走节奏，全面提升你的中路统治力。撸啊撸新手教程必读。',
    category: 'laning-tips',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20mid%20lane%20battlefield%20with%20golden%20amber%20warm%20glow%2C%20dark%20atmospheric%20arena%2C%20cinematic%20lighting%2C%20professional%20gaming%20composition%2C%20dramatic%20esports%20aesthetic&width=800&height=500&seq=mid-lane-guide&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20mid%20lane%20icon%20golden%20amber%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=mid-lane-guide-thumb&orientation=squarish',
    readTime: 10,
    publishDate: '2026-08-04',
    hot: false,
    featured: true,
    tags: ['中单', '对线技巧', '兵线控制', '新手教程'],
    content: {
      intro: '中单是撸啊撸中影响力最大的位置之一。这篇撸啊撸新手教程将帮助你从基础到进阶掌握中单对线的所有核心技巧。',
      sections: [
        {
          heading: '兵线管理基础',
          content: '兵线控制是中单对线的核心。慢推（slow push）适合准备游走或回城时使用；快推（fast push）在击杀敌人后快速将兵线推进塔下；冻结（freeze）将兵线控制在自己塔前，限制对手补刀的同时保证自身安全。',
        },
        {
          heading: '换血时机',
          content: '最佳的换血时机是对手补刀僵直时，或者在对手关键技能进入冷却后。注意观察小地图上敌方打野的位置，在确认安全的情况下再进行激进的换血。撸啊撸对线技巧的精髓在于用最小的代价获取最大的血量优势。',
        },
        {
          heading: '游走节奏',
          content: '6级之后的中单应该开始关注边路的游走机会。优先选择推线后游走，避免损失太多兵线。游走的方向应该根据兵线状态和队友的控制技能来决定。成功的游走可以滚起雪球，帮助团队建立优势。',
        },
      ],
    },
  },
  {
    id: 'art-004',
    slug: 'adc-item-build-s14',
    title: 'S14赛季ADC出装全解析：暴击流vs穿甲流',
    excerpt: '撸啊撸出装推荐：S14赛季ADC最新出装思路，暴击流与穿甲流的优劣对比，教你根据阵容选择最优装备方案。',
    category: 'item-build',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20ADC%20weapons%20and%20items%20with%20golden%20amber%20warm%20glow%2C%20dark%20gaming%20background%2C%20cinematic%20lighting%2C%20professional%20esports%20composition&width=800&height=500&seq=adc-build-guide&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20weapon%20icon%20golden%20amber%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=adc-build-guide-thumb&orientation=squarish',
    readTime: 7,
    publishDate: '2026-08-03',
    hot: false,
    featured: false,
    tags: ['ADC', '出装推荐', '装备搭配', 'S14'],
    content: {
      intro: 'ADC的出装选择直接影响团战输出能力。本篇撸啊撸出装推荐将详细分析S14赛季暴击流和穿甲流两种主流出装路线的优劣。',
      sections: [
        {
          heading: '暴击流出装',
          content: '暴击流是目前最主流的ADC出装路线。核心装备包括不朽盾弓、幻影之舞和无尽之刃。这套出装的优点在于后期输出极高，三件套成型后每下普攻都能造成恐怖的伤害。缺点是前期较脆，需要辅助的保护。适合金克丝、泽丽等攻速型ADC。',
        },
        {
          heading: '穿甲流出装',
          content: '穿甲流适合技能型ADC，如卢锡安、EZ。核心装备包括暮刃、收集者和赛瑞尔达的怨恨。优势在于爆发伤害高，中期团战能力强。但后期面对坦克时输出不如暴击流。选择穿甲流需要队伍中有足够的持续输出点。',
        },
        {
          heading: '如何选择',
          content: '面对多坦克阵容优先选择暴击流，保证后期打坦能力。对面脆皮多则穿甲流能更快滚起雪球。同时需要考虑己方阵容的输出类型，确保团队伤害类型多样化。',
        },
      ],
    },
  },
  {
    id: 'art-005',
    slug: 'teamfight-positioning-guide',
    title: '团战站位终极指南：五个位置的正确打法思路',
    excerpt: '撸啊撸团战技巧全解析：详解上单、打野、中单、ADC、辅助在团战中的正确站位和打法思路，大幅提升团战胜率。',
    category: 'teamfight',
    image: 'https://readdy.ai/api/search-image?query=Epic%20League%20of%20Legends%20team%20battle%20with%20golden%20amber%20energy%20explosions%2C%20dark%20arena%20atmosphere%2C%20cinematic%20lighting%2C%20dramatic%20esports%20composition%2C%20five%20champions%20clashing&width=800&height=500&seq=teamfight-guide&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20team%20fight%20icon%20golden%20amber%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=teamfight-guide-thumb&orientation=squarish',
    readTime: 9,
    publishDate: '2026-08-02',
    hot: true,
    featured: false,
    tags: ['团战', '站位', '配合', '团队'],
    content: {
      intro: '团战是撸啊撸决定胜负的关键环节。很多玩家个人操作很强但团战总是输，原因往往在于站位和时机把握不当。本篇撸啊撸团战技巧将帮你解决这个问题。',
      sections: [
        {
          heading: '前排：上单与打野',
          content: '前排英雄的核心职责是开团和保护。坦克型上单应该站在队伍最前方寻找开团机会，同时注意不要与后排脱节。战士型打野需要判断是先手开团还是保护己方ADC，这取决于双方阵容的特点。',
        },
        {
          heading: '中单：刺客与法师的差异',
          content: '刺客型中单需要从侧翼切入，优先锁定敌方ADC或中单。法师型中单应该站在后排输出，利用技能范围优势poke敌人。无论哪种类型，中单都需要注意自己的站位安全，避免被先手秒杀。',
        },
        {
          heading: '后排：ADC与辅助',
          content: 'ADC是团战的核心输出，站位必须绝对安全。始终保持在辅助和前排的保护范围内，优先攻击最近的目标而非深入敌阵。辅助的核心任务是保护ADC，在有把握的情况下也可以寻找开团机会。',
        },
      ],
    },
  },
  {
    id: 'art-006',
    slug: 'bronze-to-gold-climb',
    title: '从青铜到黄金：低分段上分方法论',
    excerpt: '撸啊撸段位提升实战指南：针对青铜到黄金分段的系统性提升方案，从英雄池建设到心态管理全方位助你突破瓶颈。',
    category: 'rank-climb',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20ranked%20climbing%20with%20golden%20amber%20trophy%20glow%2C%20dark%20competitive%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20esports%20composition%2C%20achievement%20vibe&width=800&height=500&seq=rank-climb-guide&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20ranked%20badge%20icon%20golden%20amber%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=rank-climb-guide-thumb&orientation=squarish',
    readTime: 11,
    publishDate: '2026-08-01',
    hot: false,
    featured: false,
    tags: ['段位提升', '低分段', '上分', '排位'],
    content: {
      intro: '卡在青铜或白银无法上分？这篇撸啊撸段位提升指南将从英雄选择、对线基本功、地图意识到心态管理，系统性地帮你突破低分段瓶颈。',
      sections: [
        {
          heading: '英雄池建设',
          content: '低分段不需要精通很多英雄，专注于2-3个版本强势且操作相对简单的英雄即可。推荐中单安妮、上单盖伦、ADC金克丝，这些英雄操作门槛低但强度高，能让你专注于游戏理解而非操作。',
        },
        {
          heading: '补刀基本功',
          content: '15分钟150刀是脱离青铜的基础标准。每天花15分钟进行自定义补刀练习，逐步提升补刀稳定性。良好的补刀意味着经济领先，经济领先转化为装备优势，装备优势就是胜利的基础。',
        },
        {
          heading: '地图意识',
          content: '养成每5秒看一次小地图的习惯。当敌方打野在上路出现时，下路可以激进换血。当地图上敌方全部消失时，保持警惕不要盲目推线。视野是低分段最被忽视的胜利因素。',
        },
        {
          heading: '心态管理',
          content: '低分段最常见的失败原因是心态爆炸。遇到队友劣势时不要打字喷人，专注于自己能做的事情。每一局都是新的开始，保持良好的心态是持续上分的必要条件。',
        },
      ],
    },
  },
  {
    id: 'art-007',
    slug: 'lee-sin-jungle-guide',
    title: '盲僧李青打野节奏全攻略',
    excerpt: '盲僧是撸啊撸中最经典的打野英雄，本篇攻略详解其刷野路线、Gank时机、R闪连招与团战思路。',
    category: 'hero-guide',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20martial%20arts%20monk%20champion%20with%20golden%20amber%20warm%20glow%2C%20dark%20atmospheric%20jungle%20background%2C%20cinematic%20lighting%2C%20professional%20esports%20composition&width=800&height=500&seq=lee-sin-guide&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20monk%20icon%20golden%20amber%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=lee-sin-guide-thumb&orientation=squarish',
    readTime: 10,
    publishDate: '2026-07-30',
    hot: false,
    featured: false,
    tags: ['李青', '盲僧', '打野', 'Gank'],
    content: {
      intro: '盲僧李青是撸啊撸打野位的必修课，高操作上限让他在任何版本都有一席之地。',
      sections: [
        { heading: '刷野路线', content: '红开→石头人→F6的速三路线是盲僧最经典的打法，三级后可以立即寻找gank机会。' },
        { heading: 'Gank技巧', content: '利用W摸眼接近敌人，E技能减速后接Q确保命中率。R闪是盲僧的招牌操作，可以改变踢飞方向。' },
        { heading: '团战思路', content: '盲僧团战以保护和开团为主，R技能可以将敌方前排踢回己方阵营创造多打少的机会。' },
      ],
    },
  },
  {
    id: 'art-008',
    slug: 'support-warding-guide',
    title: '辅助视野控制完全指南',
    excerpt: '掌握撸啊撸视野布控的核心技巧，从基础眼位到高级视野压制，让你的辅助水平提升一个档次。',
    category: 'laning-tips',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20vision%20ward%20on%20dark%20map%20with%20golden%20amber%20glow%2C%20atmospheric%20gaming%20scene%2C%20cinematic%20lighting%2C%20professional%20esports%20composition&width=800&height=500&seq=warding-guide&orientation=landscape',
    thumb: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20vision%20ward%20icon%20golden%20amber%20dark%20background%20minimalist%20gaming%20emblem&width=200&height=200&seq=warding-guide-thumb&orientation=squarish',
    readTime: 8,
    publishDate: '2026-07-28',
    hot: false,
    featured: false,
    tags: ['辅助', '视野', '眼位', '地图控制'],
    content: {
      intro: '视野是撸啊撸中最被低估的胜利因素，一个好的辅助可以通过视野控制为团队创造巨大的信息优势。',
      sections: [
        { heading: '基础眼位', content: '河道草丛、龙坑入口、敌方蓝Buff区是最基础的三个眼位，覆盖了大部分gank路线。' },
        { heading: '高级视野压制', content: '利用扫描透镜清除敌方视野，配合真眼建立视野优势。在关键目标刷新前1分钟提前布控视野。' },
        { heading: '针对不同打野的眼位', content: '隐身型打野需要布置真眼在gank路线上；全球流打野需要更深的视野来提前预警。' },
      ],
    },
  },
];

export const faqs = [
  {
    question: '撸啊撸新手应该从哪个位置开始练习？',
    answer: '推荐新手从上单或辅助开始。上单对线相对独立，容易专注于基本功练习；辅助不需要补刀，可以专注于地图意识和视野控制。等基础熟练后再尝试中单和ADC等需要更高操作的位置。',
  },
  {
    question: '当前版本最强势的上分英雄有哪些？',
    answer: 'S14赛季T0级别英雄包括：上单奥恩、打野李青、中单阿狸、ADC金克丝、辅助蕾欧娜。这些英雄在各自位置上的胜率和选取率都位居前列，适合用来上分。不过撸啊撸英雄攻略强调，选择自己熟练的英雄比盲目跟风版本强势更重要。',
  },
  {
    question: '如何快速提升段位？',
    answer: '撸啊撸段位提升需要三方面并进：一是专注2-3个英雄精练，二是提升补刀和地图意识等基本功，三是保持良好的心态。每天固定练习补刀15分钟，每周回顾自己的录像找出问题，坚持下去一个月内必有效果。',
  },
  {
    question: '团战总是打不过怎么办？',
    answer: '撸啊撸团战技巧的核心是站位和时机。输出位要保持安全距离，前排要找好开团时机。建议在团战前先确认双方人数差和关键技能CD，不要盲目开团。练习时可以使用录像回放功能，分析团战中自己和队友的站位问题。',
  },
  {
    question: '出装应该选择推荐装还是自己搭配？',
    answer: '撸啊撸出装推荐先使用游戏内置的推荐出装作为基础，然后根据对局情况灵活调整。面对多AP阵容优先补魔抗装，面对多AD阵容优先补护甲装，对面治疗多则出重伤装备。出装思路的核心是针对性，不要死板地每局都出相同的装备。',
  },
];

export const testimonials = [
  {
    name: '峡谷之巅大师玩家 - 小明',
    text: '撸啊撸攻略大全的内容非常专业，尤其是亚索的连招教学让我从白银一路打到了钻石！强烈推荐给所有想提升的玩家。',
    rating: 5,
  },
  {
    name: '游戏主播 - 电竞小王子',
    text: '作为全职主播，我经常推荐粉丝来看撸啊撸攻略大全，内容系统全面，从新手到高手都能找到有用的信息。',
    rating: 5,
  },
  {
    name: '大学生玩家 - 阿杰',
    text: '从青铜到黄金的攻略真的帮了我大忙，按照上面的方法练习了一个月，补刀和意识都有了明显提升。',
    rating: 5,
  },
];

export const stats = [
  { label: '攻略文章', value: '200+' },
  { label: '覆盖英雄', value: '160+' },
  { label: '月活读者', value: '50万+' },
  { label: '好评率', value: '98%' },
];